module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "ch4"
    }
  }, [_vm._v("BIRTH TO OUR PEOPLE")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Birth to our people—it was she,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Shepherdess Inception, who")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("gave birth to our people. How?")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She offered sacrifice, prayers")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("that she not be without child,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("wandered the Lord’s footprint, quickened")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and conceived. She grew round,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("dawn-life stirring there within,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("she gave birth and she suckled,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("and the child—it was Millet God.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And so those months eased by")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and the birth—it was effortless.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Free of all rending and tearing,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("free of pain and affliction, she")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("brought forth divine splendor.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The Celestial Lord soothing her,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("welcoming sacrifice and prayer,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("she bore her son in tranquillity.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And so he was left alone in a narrow lane,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("but oxen and sheep nurtured him.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And so he was left alone on a forested plain,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("but woodcutters gathered round.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And so he was left alone on a cold ice-field,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("but birds wrapped him in wings,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and when the birds took flight,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Millet God began to wail, he")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("wailed long and wailed loud,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("and the sound was deafening.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And so he soon began to crawl,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("then stood firm as a mountain.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("When he began to feed himself")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("he planted broad-beans aplenty,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("broad and wind-fluttered beans,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and lush grain ripening in rows,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("wheat and hemp thick and rich,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("and melons sprawled everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And so Millet God farmed, understanding")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("the Way to help things grow.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He cleared away thick grass")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and planted yellow treasure.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The seeds swelled and rooted.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Planted well, they grew lovely,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("grew tall and lovely in bloom,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("they ripened to a fine finish")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and bent low with rich plenty.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("He built a house there, in T’ai, and settled.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And so he gave to us exquisite")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("millet: midnight and twin-seed,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("red-shafted and white-frosted.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He grew midnight and twin-seed")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("far and wide, cut acre after acre,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("cut red-shafted and white-frosted,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("hauled it in, shoulder and back")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("home to begin offering sacrifice.")]), _vm._v(" "), _c('p', {
    staticClass: "v",
    attrs: {
      "id": "pg13"
    }
  }, [_vm._v("And so our offerings—how are they done?")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Some thresh and some sweep,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("some winnow and some tread;")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("we wash it clean, whisper-clean,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and steam it misty, misty sweet.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Pondering deeply, thoughts pure,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("we offer artemisia soaked in fat,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("offer rams to spirits far and wide,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and meat smoke-seared we offer")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("to bring forth another new year.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("We offer bounty in altar bowls,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("in altar bowls and holy platters,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and when the fragrance ascends,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("fragrance perfect in its season,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("our Celestial Lord rests content.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Millet God began these offerings,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and free of trespass always they")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("continued down to our own time.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f0bc0ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter4.vue
// module id = 84
// module chunks = 0